module.exports = __webpack_public_path__ + "img/logo.82503c47.svg";